import React from 'react';
import { Link } from 'react-router-dom';
import GetSvg from '../../vendor/GetSvg';
import getLevelFillPercent from './getLevelFillPercent';

const AchievementLevel = ({ currentLevel, nextLevel }) => {
  const fillPercent = getLevelFillPercent(nextLevel);

  return (
    <div className="achievement-level">
      <div className="achievement-level__progress">
        <div
          className="achievement-level__bar"
          style={{ '--level-fill': `${fillPercent}%` }}>
          <span className="achievement-level__bar-cap" />
          <span className="achievement-level__bar-track" />
          <span className="achievement-level__bar-label">
            {currentLevel?.name}
          </span>
        </div>

        <div className="achievement-level__next">
          {nextLevel ? (
            <div className="achievement-level__next-title">
              Next Status Level
            </div>
          ) : null}
          <div className="achievement-level__next-name">
            {nextLevel ? nextLevel.name : 'Top Level Achieved'}
          </div>
        </div>
      </div>

      <div className="achievement-level__heading">
        Unlock Seals, Unlock Rewards
      </div>

      <Link className="achievement-level__link" to="/loyalty">
        Learn more about the loyalty programme
        <GetSvg svg="arrow_right" wrapperClass="svg achievement-level__arrow" />
      </Link>
    </div>
  );
};

export default AchievementLevel;
